import { Alert, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const SubscriptionPromoBar = ({ trialDaysLeft, subscriptionIsActive }) => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);

  // Only show if trial is valid and within last 7 days
  if (!visible || !trialDaysLeft || trialDaysLeft > 7) return null;

  const message =
    trialDaysLeft > 2
      ? `🎉 Your free trial ends in ${trialDaysLeft} day${
          trialDaysLeft > 1 ? "s" : ""
        }.`
      : `⚡ Your free trial is almost over! Only ${trialDaysLeft} day${
          trialDaysLeft > 1 ? "s" : ""
        } left.`;

  return (
    <div
      style={{
        background: "linear-gradient(90deg, #9254de 0%, #b37feb 100%)",
        color: "#fff",
        padding: "8px 16px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 10,
        position: "relative",
      }}
    >
      <span style={{ fontWeight: 500 }}>{message}</span>
      <Button
        type="primary"
        size="small"
        style={{
          background: "#fff",
          color: "#722ed1",
          border: "none",
          fontWeight: 500,
        }}
        onClick={() => navigate("/pricing")}
      >
        Upgrade Now
      </Button>

      <CloseOutlined
        onClick={() => setVisible(false)}
        style={{
          position: "absolute",
          right: 16,
          cursor: "pointer",
          color: "rgba(255,255,255,0.8)",
          fontSize: 14,
        }}
      />
    </div>
  );
};

export default SubscriptionPromoBar;
